import asyncSweetScroll from '@/helpers/sweet_scroll';
import track from '@/helpers/track';

let videoObserver = null;

$(document).on('turbolinks:before-cache', () => {
  if (videoObserver) {
    videoObserver.disconnect();
    videoObserver = null;
  }
});

function replaceWithVideo(picture) {
  const video = document.createElement('video');

  video.src = picture.dataset.video_url;
  video.autoplay = true;
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  picture.replaceWith(video);
}

pageLoad('pages_promo', () => {
  videoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      videoObserver.unobserve(entry.target);
      replaceWithVideo(entry.target);
    });
  });

  $('article.v4.slide_1 picture[data-video_url]').each((_, el) => {
    videoObserver.observe(el);
  });

  $('article.v4.slide_1 .to-map').on('click', () => {
    asyncSweetScroll('article.v4.storages_map');
  });

  $('article.v4.slide_1 .lead').on('click', ({ currentTarget }) => {
    $('footer.b-footer.v4 button.lead').click();
  });
});
